import { Create } from "react-admin";
import { JobApplicationSourceForm } from "./index";

export const JobApplicationSourceCreate = () => (
  <Create>
    <JobApplicationSourceForm />
  </Create>
);
